class CustomLoyaltyButton extends HTMLElement {
  constructor() {
    super();

    this.customLoyaltyButton = this.querySelector('[data-loyalty-button]');

    CustomLoyaltyButton.registerMutationObservers();
    this.registerEventListeners();
  }

  static registerMutationObservers() {
    // Check the body for marsello related mutations.
    const targetNode = document.body;

    // We only want to check the child list.
    const config = { attributes: false, childList: true, subtree: false };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      // Loop over all the mutations...
      mutationList.forEach(mutation => {
        // Check if the mutation is a child list mutation, which has added nodes...
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // If so, loop over the added nodes...
          [...mutation.addedNodes].forEach(addedNode => {
            // Check if the added node has an id of marsello-area...
            if (addedNode.id === 'marsello-area') {
              // If so, the Marsello elements have started to be added.
              // We no longer need the observer, so we can disconnect it.
              observer.disconnect();

              // Now we need to wait for the marsello widget to be added to the DOM.
              // We do this by checking the DOM every 250ms for 20 seconds.
              let count = 0;
              const interval = setInterval(() => {
                count += 1;
                const widget = addedNode.querySelector('#marsello-widget');
                // Check if the widget exists...
                if (widget) {
                  // If so, unhide it...
                  widget.setAttribute('aria-hidden', false);
                  // And cancel the looping.
                  clearInterval(interval);
                }

                // Check if we have done 80 loops (for 20 seconds)...
                if (count >= 80) {
                  // If so, cancel the looping.
                  clearInterval(interval);
                }
              }, 250);
            }
          });
        }
      });
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

  registerEventListeners() {
    this.customLoyaltyButton.addEventListener('click', () => {
      const loyaltyTab = document.querySelector('#marsello-tab');

      if (loyaltyTab) {
        const loyaltyTabContent =
          loyaltyTab.contentDocument || loyaltyTab.contentWindow.document;
        const loyaltyTabButton =
          loyaltyTabContent.querySelector('.marsello-tab');

        // Hijack the loyalty button and open the loyalty menu.
        loyaltyTabButton.click();
      }
    });
  }
}

customElements.define('custom-loyalty-button', CustomLoyaltyButton);
